import api from '../_api';

const actions = {
    getSeasons: ({commit}) => {

        return new Promise((resolve, reject) => {
            commit('RESET_STATE');
            commit('REFEREE_LOADING');

            api.getSeasons()
                .then((resp) => {
                    commit('SEASONS_SUCCESS', resp.data.data);
                    resolve(resp.data);
                })
                .catch((err) => {
                    let errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;

                    commit('REFEREE_ERROR', errors);
                    reject(err.response);
                });
        })
    },
    getVenues: ({commit}) => {

        return new Promise((resolve, reject) => {
            commit('RESET_STATE');
            commit('REFEREE_LOADING');

            api.getVenues()
                .then((resp) => {
                    commit('VENUES_SUCCESS', resp.data.data);
                    resolve(resp.data);
                })
                .catch((err) => {
                    let errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;

                    commit('REFEREE_ERROR', errors);
                    reject(err.response);
                });
        })
    },
    getRoster: ({commit}, payload) => {

        return new Promise((resolve, reject) => {
            commit('REFEREE_LOADING');

            api.getRosterByCurrentUser(payload.sel_season, payload.roster_date, payload.sel_type)
                .then((resp) => {
                    commit('ROSTER_SUCCESS', resp.data.data);
                    resolve(resp.data);
                })
                .catch((err) => {
                    let errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;

                    commit('REFEREE_ERROR', errors);
                    reject(err.response);
                });
        })
    },
    getAvailability: ({commit}, payload) => {

        return new Promise((resolve, reject) => {
            commit('REFEREE_LOADING');

            api.getAvailabilityByCurrentUser(payload.sel_season, payload.sel_venue)
                .then((resp) => {
                    commit('AVAIL_SUCCESS', resp.data.data);
                    resolve(resp.data);
                })
                .catch((err) => {
                    let errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;

                    commit('REFEREE_ERROR', errors);
                    reject(err.response);
                });
        })
    },
    postAvailability: ({ commit, dispatch, state }, payload) => {

        return new Promise((resolve, reject) => {
            commit('REFEREE_LOADING');

            api.postAvailabilityByCurrentUser(payload.sel_season, payload.sel_venue, state.availability.refGameTimes, state.availability.unavailability)
                .then((resp) => {
                    commit('POST_AVAIL_SUCCESS', resp.data.data);
                    resolve(resp.data);
                })
                .catch((err) => {
                    let errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;

                    commit('REFEREE_ERROR', errors);
                    reject(err.response);
                });
        })
    },
    updateUnavail: ({ commit }, payload) => {
        commit("UPDATE_TO_UNAVAIL", payload);
    },
    addAvail: ({ commit }, payload) => {
        commit("ADD_TO_AVAIL", payload);
    },
    clearRefereeErrors:({commit}) => {
        commit('CLEAR_REFEREE_ERRORS');
    },
}

export default actions
